import { render, staticRenderFns } from "./ComfortableSection.vue?vue&type=template&id=8a7ea7ee&scoped=true&"
import script from "./ComfortableSection.vue?vue&type=script&lang=js&"
export * from "./ComfortableSection.vue?vue&type=script&lang=js&"
import style0 from "./ComfortableSection.vue?vue&type=style&index=0&id=8a7ea7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ea7ee",
  null
  
)

export default component.exports